var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6159 5.34863C20.0487 5.34863 19.1733 6.88904 19.5299 8.03365L15.6931 11.8419C15.3689 11.7456 14.8933 11.7456 14.5691 11.8419L11.8131 9.11408C12.1805 7.96947 11.3051 6.41836 9.72715 6.41836C8.16 6.41836 7.27374 7.95877 7.64121 9.11408L2.71279 13.9813C1.55634 13.6283 0 14.4948 0 16.0459C0 17.2226 0.972715 18.1854 2.16159 18.1854C3.72874 18.1854 4.60418 16.645 4.24752 15.5003L9.16513 10.6224C9.48937 10.7187 9.96492 10.7187 10.2892 10.6224L13.0452 13.3502C12.6777 14.4948 13.5532 16.0459 15.1311 16.0459C16.6983 16.0459 17.5845 14.5055 17.2171 13.3502L21.0647 9.55266C22.2211 9.90567 23.7775 9.03919 23.7775 7.48809C23.7775 6.31139 22.8048 5.34863 21.6159 5.34863Z",
    fill: "url(#paint0_linear_214_543)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1311 6.41837L16.147 4.20403L18.3734 3.20918L16.147 2.21434L15.1311 0L14.1367 2.21434L11.8887 3.20918L14.1367 4.20403L15.1311 6.41837Z",
    fill: "url(#paint1_linear_214_543)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70199 8.55783L3.24238 6.41837L5.40397 5.8835L3.24238 5.34864L2.70199 3.20918L2.16159 5.34864L0 5.8835L2.16159 6.41837L2.70199 8.55783Z",
    fill: "url(#paint2_linear_214_543)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_214_543",
    x1: 11.8887,
    y1: 5.34863,
    x2: 11.8887,
    y2: 18.1854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_214_543",
    x1: 15.1311,
    y1: 0,
    x2: 15.1311,
    y2: 6.41837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_214_543",
    x1: 2.70199,
    y1: 3.20918,
    x2: 2.70199,
    y2: 8.55783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.aedf49ff1297f551e147e9b82350c3d8.svg";
export { ForwardRef as ReactComponent };